/* SessionStorage */
import DateClass from '@/app/module/date'

class Session {
  /* field */
  // 圃場一覧を構成するためのデータ
  public setFieldData (fieldData: string) {
    sessionStorage.setItem('fieldData', fieldData)
  }
  public getFieldData () {
    return sessionStorage.getItem('fieldData')
  }

  // デフォルトの圃場一覧
  public setAllFieldData (allFieldData: string) {
    sessionStorage.setItem('allFieldData', allFieldData)
  }
  public getAllFieldData () {
    return sessionStorage.getItem('allFieldData')
  }

  // 圃場の詳細データを構成するためのデータ
  public setFieldDetailsData (data: string, id: string) {
    sessionStorage.setItem(`details_area_${id}`, data)
  }
  public getFieldDetailsData (id: string) {
    return sessionStorage.getItem(`details_area_${id}`)
  }

  // 直前に選択した圃場IDを保持
  public setChoiceFieldId (id: string) {
    sessionStorage.setItem('choiceFiledId', id)
  }
  public getChoiceFieldId () {
    return sessionStorage.getItem('choiceFiledId')
  }

  /* fieldDetails */
  // 紐づいている目標のID
  public setVarietyId (id: string) {
    sessionStorage.setItem('varietyId', id)
  }
  public getVarietyId () {
    return sessionStorage.getItem('varietyId')
  }

  // 播種日
  public setPlantingDay (val: string) {
    sessionStorage.setItem('plantingDay', val)
  }
  public getPlantingDay () {
    return sessionStorage.getItem('plantingDay')
  }

  // 播種日の最短
  public setEarliestHarvestDay (val: string) {
    sessionStorage.setItem('earliestHarvestDay', val)
  }
  public getEarliestHarvestDay () {
    return sessionStorage.getItem('earliestHarvestDay')
  }

  // 播種日の最終
  public setLatestHarvestDay (val: string) {
    sessionStorage.setItem('latestHarvestDay', val)
  }
  public getLatestHarvestDay () {
    return sessionStorage.getItem('latestHarvestDay')
  }

  // 目標収穫最早期
  public setGoalEarliestHarvestDay (val: string) {
    sessionStorage.setItem('goalEarliestHarvestDay', val)
  }
  public getGoalEarliestHarvestDay () {
    return sessionStorage.getItem('goalEarliestHarvestDay')
  }

  // 目標収穫最遅期
  public setGoalLatestHarvestDay (val: string) {
    sessionStorage.setItem('goalLatestHarvestDay', val)
  }
  public getGoalLatestHarvestDay () {
    return sessionStorage.getItem('goalLatestHarvestDay')
  }

  // 検証収穫最早期
  public setTestEarliestHarvestDay (val: string) {
    sessionStorage.setItem('testEarliestHarvestDay', val)
  }
  public getTestEarliestHarvestDay () {
    return sessionStorage.getItem('testEarliestHarvestDay')
  }

  // 検証収穫最遅期
  public setTestLatestHarvestDay (val: string) {
    sessionStorage.setItem('testLatestHarvestDay', val)
  }
  public getTestLatestHarvestDay () {
    return sessionStorage.getItem('testLatestHarvestDay')
  }

  // 収穫適期日
  public setEstimatedDate (val: string) {
    sessionStorage.setItem('estimatedDate', val)
  }
  public getEstimatedDate () {
    return sessionStorage.getItem('estimatedDate')
  }

  // 圃場ID
  public setFieldId (id: string) {
    sessionStorage.setItem('fieldId', id)
  }
  public getFieldId () {
    return sessionStorage.getItem('fieldId')
  }

  // ステージバーを構成するためのデータ
  public setGrowthStage (val: string) {
    sessionStorage.setItem('growthStage', val)
  }
  public getGrowthStage () {
    return sessionStorage.getItem('growthStage')
  }

  // 作付けID
  public setPlantingId (id: string) {
    sessionStorage.setItem('plantingId', id)
  }
  public getPlantingId () {
    return sessionStorage.getItem('plantingId')
  }

  // グラフの実測値を構成するためのデータ
  public setGraphData (graphData: string) {
    sessionStorage.setItem('graphData', graphData)
  }
  public getGraphData () {
    return sessionStorage.getItem('graphData')
  }

  // デフォルトのグラフデータ
  public setDefaultGraphData (graphData: string) {
    sessionStorage.setItem('defaultGraphData', graphData)
  }
  public getDefaultGraphData () {
    return sessionStorage.getItem('defaultGraphData')
  }

  // 実測の収穫ステータス
  public setHarvestStatus (val: number|any) {
    sessionStorage.setItem('harvestStatus', val)
  }
  public getHarvestStatus () {
    return sessionStorage.getItem('harvestStatus')
  }

  // 実測の収穫ステータス変更日
  public setHarvestStatusDay (val: string|any) {
    sessionStorage.setItem('harvestStatusDay', val)
  }
  public getHarvestStatusDay () {
    return sessionStorage.getItem('harvestStatusDay')
  }

  // 実測グラフの最終日
  public setGraphLastDay (val: string|any) {
    sessionStorage.setItem('graphLastDay', val)
  }
  public getGraphLastDay () {
    return sessionStorage.getItem('graphLastDay')
  }

  // 予測グラフを構成するためのデータ
  public setPredictionData (predictionData: string) {
    sessionStorage.setItem('predictionData', predictionData)
  }
  public getPredictionData () {
    return sessionStorage.getItem('predictionData')
  }

  // 検証グラフを構成するためのデータ
  public setTestData (TestData: string) {
    sessionStorage.setItem('testData', TestData)
  }
  public getTestData () {
    return sessionStorage.getItem('testData')
  }

  // 目標グラフを構成するためのデータ
  public setMasterData (masterData: string) {
    sessionStorage.setItem('masterData', masterData)
  }
  public getMasterData () {
    return sessionStorage.getItem('masterData')
  }

  // 比較グラフを構成するためのデータ
  public setComparisonData (comparisonData: string) {
    sessionStorage.setItem('comparisonData', comparisonData)
  }
  public getComparisonData () {
    return sessionStorage.getItem('comparisonData')
  }

  // 比較の予測データ
  public getComparisonPredictionData () {
    return sessionStorage.getItem('comparisonPrediction')
  }
  public setComparisonPredictionData (comparisonPrediction: string) {
    sessionStorage.setItem('comparisonPrediction', comparisonPrediction)
  }

  // 幼穂長の目標データ
  public getYoungGoalData () {
    return sessionStorage.getItem('youngGoal')
  }
  public setYoungGoalData (youngGoal: string) {
    sessionStorage.setItem('youngGoal', youngGoal)
  }

  // 比較グラフを構成するためのデータ
  public setComparisonYoungData (comparisonYoungData: string) {
    sessionStorage.setItem('comparisonYoungData', comparisonYoungData)
  }
  public getComparisonYoungData () {
    return sessionStorage.getItem('comparisonYoungData')
  }

  // 幼穂長のデータ
  public getYoungData () {
    return sessionStorage.getItem('youngData')
  }
  public setYoungData (youngData: string) {
    sessionStorage.setItem('youngData', youngData)
  }

  // 比較のステージデータ
  public getComparisonStageData () {
    return sessionStorage.getItem('comparisonStage')
  }
  public setComparisonStageData (comparisonStage: string) {
    sessionStorage.setItem('comparisonStage', comparisonStage)
  }

  // 生育データを構成するためのデータ
  public setSensorData (data: string, id: string) {
    sessionStorage.setItem(`sensor_${id}`, data)
  }
  public getSensorData (id: string) {
    return sessionStorage.getItem(`sensor_${id}`)
  }

  // アグリノート連携画像ID
  public getAgrinoteRecods () {
    return sessionStorage.getItem('agrinoteRecods')
  }
  public setAgrinoteRecods (agrinoteRecods: string) {
    sessionStorage.setItem('agrinoteRecods', agrinoteRecods)
  }

  /* キャッシュの期限 */
  public async clearSensorCache () {
    for (var key in sessionStorage) {
      if (key.split('_')[0] === 'sensor') {
        // ローカルストレージのタイムスタンプ
        let data = new Date(JSON.parse(sessionStorage[key])[0].timestamp)
        // 期限日(次の日の7:00)
        let timeLimit = new Date('' + data.getFullYear() + '-' + DateClass.toDoubleDigits(data.getMonth() + 1) + '-' + DateClass.toDoubleDigits(data.getDate() + 1) + 'T07:00:00')
        // 今
        let now = new Date()

        if (now > timeLimit) {
          await sessionStorage.removeItem(key)
        }
      }
    }
  }

  public async clearDetailsCache () {
    for (var key in sessionStorage) {
      if (key.split('_')[0] === 'details') {
        // ローカルストレージのタイムスタンプ
        let data = new Date(JSON.parse(sessionStorage[key])[0].timestamp)
        // 期限日(次の日の9:30)
        let timeLimit = new Date('' + data.getFullYear() + '-' + DateClass.toDoubleDigits(data.getMonth() + 1) + '-' + DateClass.toDoubleDigits(data.getDate() + 1) + 'T09:30:00')
        // 今
        let now = new Date()

        if (now > timeLimit) {
          await sessionStorage.removeItem(key)
        }
      }
    }
  }

  /* storage削除 */
  public clear () {
    sessionStorage.clear()
  }
}

export default new Session()
